import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

const CustomizedComponent = styled(TextField)(({ theme, type }) => ({
  width: "100%",
  color: theme.palette.commonground.contrastText,
  transform: "scale(1)",
  "& .MuiSelect-icon": {
    transition: "all 0.25s ease-in-out",
  },

  "& .MuiInputBase-input": {
    textAlign: type === "number" ? "center" : "start",
  },
  "& .MuiInputBase-root:not(.Mui-disabled)": {
    "&:hover": {
      "& > fieldset": {
        borderColor: alpha(theme.palette.secondary.main, 0.75),
      },
      "& .MuiSelect-icon": {
        transition: "all 0.25s ease-out",
        "& > path": {
          color: theme.palette.secondary.main,
        },
      },
    },
    "&.Mui-focused fieldset": {
      borderColor: alpha(theme.palette.secondary.main, 0.75),
      "& .MuiSelect-icon": {
        "& > path": {
          color: theme.palette.secondary.main,
        },
      },
    },
    "& .MuiSelect-iconOpen": {
      transition: "all 0.25s ease-out",
      "& > path": {
        color: theme.palette.secondary.main,
      },
    },
    "& .MuiIconButton-edgeStart": {
      marginLeft: `-${theme.spacing(1)}`,
    },
    "& .MuiIconButton-edgeEnd": {
      marginRight: `-${theme.spacing(1)}`,
    },
    "& .MuiIconButton-root, .MuiSvgIcon-root": {
      "&:hover": {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.secondary.light,
        transform: "scale(1.075)",
      },
      "&:active": {
        transform: "scale(0.98)",
      },
    },
  },
}));

const OmniTextField = props => {
  const {
    children,
    color = "secondary",
    rowCount = 1,
    multiline = false,
    onChange = null,
    label = "Missing",
    type = "text",
    size = "small",
    variant = "outlined",
    error = false,
    helperText = "",
    showNumberControls = true,
    ...other
  } = props;

  return (
    <CustomizedComponent
      autofill="off"
      //prevents AutoComplete Suggestions
      autoComplete="off"
      label={label}
      value={props.value}
      variant={variant}
      color={color}
      margin="dense"
      multiline={multiline}
      rows={rowCount}
      type={type}
      size={size}
      helperText={helperText}
      error={error}
      inputProps={{
        autoComplete: "off",
      }}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        startAdornment:
          type === "number" && showNumberControls ? (
            <InputAdornment position="start">
              <IconButton
                tabIndex={-1}
                disabled={props.value < 1}
                size="small"
                edge="start"
                onClick={event => {
                  if (onChange != null) {
                    // explicitly set props.value to type Number
                    // otherwise it appends 1 to
                    // props.value "" => 1 => 11 => 111
                    // when clicked
                    event.target["value"] = props.value < 1 ? Number(0) : Number(props.value) - 1;
                    onChange(event);
                  }
                }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        endAdornment:
          type === "number" && showNumberControls ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                tabIndex={-1}
                onClick={event => {
                  if (onChange != null) {
                    event.target["value"] = Number(props.value) + 1;
                    onChange(event);
                  }
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        inputMode: type === "number" ? "numeric" : "text",
      }}
      onChange={event => {
        if (onChange != null) {
          onChange(event);
        }
      }}
      {...other}
    >
      {children}
    </CustomizedComponent>
  );
};

export default OmniTextField;
